import { AUTH_ROUTES } from '@/app/auth/_common/routes.ts';
import { Navigate } from 'react-router-dom';

export default function InitPage() {
  return <Navigate to={AUTH_ROUTES.LOGIN} replace={true} />;
}
